import Vue from 'vue'
import Vuetify from 'vuetify'
import themes from './theme'
// import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'

const opts = {
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        dark: false,
        themes
    }
}

Vue.use(Vuetify)

export default new Vuetify(opts)
